export default "__VITE_ASSET__3edb81f6__"